app.components.form = {
    onReady: (container) => {
        if ($('.wpforms-container').length) {
            return true;
        }
    },
    addListener: async () => {

        const container = $('.wpforms-container');

        try {
            window.jcf = await import('jcf/dist/js/jcf.js');
            await import('jcf/dist/js/jcf.radio.js');
            await import('jcf/dist/js/jcf.checkbox.js');
            window.jcf.replaceAll(container);
        } catch (error) {
            console.error('Error loading JCF modules:', error);
        }

        $('input, textarea, select', container).on('input change', function () {
            var $field = $(this).closest('div.wpforms-field');
            if (this.value) {
                $field.addClass('field--not-empty');
            } else {
                $field.removeClass('field--not-empty');
            }
        }).trigger('input');

        $('input, textarea, select', container).on('focusin', function () {
            var $field = $(this).closest('div.wpforms-field');
            $field.addClass('field--not-empty');
        }).on('focusout', function () {
            $(this).trigger('input')
        });

        $('.wpforms-recaptcha-hidden').attr('area-hidden', 'true');
    }
};
